<div class="container">
  <div
    fxLayout="column"
    fxLayoutAlign="center center"
    fxFill
    class="main"
  >
    <div fxLayout="column" fxLayoutAlign="center center" class="form-side">
      <!-- Estado: formulario -->
      <form
        *ngIf="!submitted"
        fxLayout="column"
        class="recover-box"
        (ngSubmit)="onSubmit()"
        #form="ngForm"
      >
        <div class="brand">
          <img src="../../../../assets/img/wazir/wazir-logo-full.png" alt="WAZIR ERP" class="brand-logo" />
        </div>
        <div class="box-title">Recuperar Senha</div>
        <div class="box-subtitle">
          Informe seu e-mail cadastrado e enviaremos as instruções para redefinir sua senha.
        </div>

        <div class="field">
          <label for="email">E-MAIL</label>
          <input
            id="email"
            type="email"
            [(ngModel)]="email"
            name="email"
            required
            email
            placeholder="Digite seu e-mail"
            autocomplete="email"
          />
        </div>

        <button
          class="btn-primary"
          type="submit"
          [disabled]="loading || form.form.invalid"
        >
          {{ loading ? 'ENVIANDO...' : 'ENVIAR INSTRUÇÕES' }}
        </button>

        <div class="back-link">
          <a [routerLink]="['/login']">Voltar para o login</a>
        </div>
      </form>

      <!-- Estado: confirmacao (sempre neutro) -->
      <div *ngIf="submitted" class="recover-box confirmation">
        <div class="brand">
          <img src="../../../../assets/img/wazir/wazir-logo-full.png" alt="WAZIR ERP" class="brand-logo" />
        </div>
        <div class="confirm-icon">&#10003;</div>
        <div class="box-title">Verifique seu e-mail</div>
        <div class="box-subtitle">
          Se o endereço <strong>{{ email }}</strong> estiver cadastrado, você receberá as instruções para redefinir sua senha em instantes.
        </div>
        <div class="box-subtitle" style="margin-top: 8px; font-size: 0.82rem;">
          Não recebeu? Verifique a caixa de spam ou tente novamente.
        </div>

        <button class="btn-secondary" type="button" (click)="submitted = false">
          TENTAR NOVAMENTE
        </button>

        <div class="back-link">
          <a [routerLink]="['/login']">Voltar para o login</a>
        </div>
      </div>
    </div>
  </div>
</div>
